import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUserState } from '../../lib/userState';
import { getSeasonalTip } from '../../data/seasonalHouseTips';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

// Full-width seasonal strip. Soft blue wash that fades to white top and
// bottom (same hand-off idea as the Shortlist section), brand-blue accents,
// no icons. Browsable by month; edition follows the state chip.
const SeasonStrip = ({ className = '' }) => {
  const userState = useUserState();
  const state = userState === 'VIC' ? 'VIC' : 'SA';
  const now = new Date().getMonth();
  const [month, setMonth] = useState(now);
  const navBtn = 'w-8 h-8 rounded-full bg-white border border-[#cfe3fb] flex items-center justify-center text-[#1d8efe] text-[18px] leading-none hover:bg-[#1d8efe] hover:text-white hover:border-[#1d8efe] transition-colors shrink-0';

  const t = getSeasonalTip(state, month);
  const rawTitle = t.title.replace(/^[A-Za-z]+:\s*/, '');
  const title = rawTitle.charAt(0).toUpperCase() + rawTitle.slice(1);

  return (
    <section
      className={`w-full ${className}`}
      style={{ background: 'linear-gradient(to bottom, #ffffff 0%, #e8f2ff 46%, #e8f2ff 54%, #ffffff 100%)' }}
      data-testid="season-strip"
      aria-label="Seasonal house tip"
    >
      <div className="max-w-[1240px] mx-auto px-4 sm:px-6 lg:px-8 py-7 sm:py-9">
        <div className="flex flex-col lg:flex-row lg:items-center gap-3.5 lg:gap-6">
          {/* Month browser */}
          <div className="flex items-center justify-center gap-2.5 shrink-0 lg:pr-6 lg:border-r lg:border-[#cfe3fb]">
            <button type="button" onClick={() => setMonth((month + 11) % 12)} className={navBtn} aria-label="Previous month" data-testid="season-prev">&#8249;</button>
            <div className="text-center min-w-[104px] leading-tight">
              <div className="text-[18px] sm:text-[20px] font-bold text-[#0a2540]" data-testid="season-month">{MONTHS[month]}</div>
              <div className="text-[10px] uppercase tracking-[0.07em] text-[#1d8efe] font-semibold" data-testid="season-edition">{state === 'VIC' ? 'Victoria' : 'South Australia'}</div>
            </div>
            <button type="button" onClick={() => setMonth((month + 1) % 12)} className={navBtn} aria-label="Next month" data-testid="season-next">&#8250;</button>
          </div>

          {/* Tip + links, inline */}
          <div className="min-w-0 flex-1 flex flex-col lg:flex-row lg:items-center gap-2.5 lg:gap-5 text-center lg:text-left" data-testid="season-strip-active">
            <div className="min-w-0 flex-1">
              <p className="text-[15px] sm:text-[16px] font-bold text-[#0a2540] leading-snug" data-testid="season-strip-title">{title}</p>
              <p className="text-[13px] sm:text-[14px] text-[#5a6b7f] leading-[1.45] mt-0.5">{t.body}</p>
            </div>
            <div className="flex flex-wrap justify-center lg:justify-end gap-2 shrink-0">
              {t.links.map((l) => (
                <Link key={l.to + l.label} to={l.to} className="inline-flex items-center text-[13px] font-semibold bg-[#1d8efe] text-white px-4 py-2 rounded-full hover:bg-[#0c6fd6] transition-colors shadow-sm" data-testid="season-strip-link">{l.label}</Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SeasonStrip;
